function emptyFunction() {} // TODO: use Event type


export function register(config) {
  var serviceWorker = navigator.serviceWorker;

  if (serviceWorker) {
    registerValidSW(serviceWorker, config);
  }
}

function registerValidSW(serviceWorker, _ref) {
  var serviceWorkerUrl = _ref.serviceWorkerUrl,
      _ref$onRegister = _ref.onRegister,
      onRegister = _ref$onRegister === void 0 ? emptyFunction : _ref$onRegister,
      _ref$onUpdate = _ref.onUpdate,
      onUpdate = _ref$onUpdate === void 0 ? emptyFunction : _ref$onUpdate,
      _ref$onActivate = _ref.onActivate,
      onActivate = _ref$onActivate === void 0 ? emptyFunction : _ref$onActivate,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? emptyFunction : _ref$onError;

  function checkUpdateAvailable(registration) {
    if (registration.waiting && serviceWorker.controller) {
      onUpdate(registration.waiting);
    }
  }

  serviceWorker.register(serviceWorkerUrl).then(function (registration) {
    onRegister(registration);
    checkUpdateAvailable(registration);

    registration.onupdatefound = function () {
      // $FlowFixMe
      registration.installing.onstatechange = function (_ref2) {
        var target = _ref2.target;

        switch (target.state) {
          case 'installed':
            target.firstWorker = !Boolean(serviceWorker.controller);
            checkUpdateAvailable(registration);
            break;

          case 'activated':
            if (!target.firstWorker) {
              onActivate();
            }

            break;
        }
      };
    };
  })["catch"](function (error) {
    onError(error);
  });
}

export function unregister() {
  if (navigator.serviceWorker) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}